<template>
  <div class="container" v-if="checkSuccShow">
    <img class="box_img" crossorigin="anonymous" v-if="dataUrl" :src="dataUrl" alt />
    <div class="box" v-else id="checkSuccess_box">
      <img
        class="box_img_bkg"
        crossorigin="anonymous"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/check_succ_bkg.png"
        alt
      />
      <div class="content">
        <div class="text1">令人钦佩的{{userInfo.nickName}}</div>
        <div class="text2">恭喜你拿下【{{dakaInfo.activityName}}】</div>
        <div class="text3">
          <div>{{dakaInfo.continuousMaxDakaNumber}}天</div>连续打卡的成就！
        </div>
      </div>
    </div>
    <div class="tip">长按可保存图片分享</div>
    <div class="close_box">
      <img
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/check_succ_close.png"
        alt
        @click="onClose"
      />
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';

export default {
  props: {
    checkSuccShow: {
      type: Boolean,
      default: false,
    },
    dakaInfo: {
      type: Object,
      default: () => {},
    },
    userInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dataUrl: '',
    };
  },
  methods: {
    onClose() {
      this.$emit('onCheckSuccClose');
    },
  },
  watch: {
    checkSuccShow: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            html2canvas(document.getElementById('checkSuccess_box'), {
              dpi: 300,
              useCORS: true,
              backgroundColor: 'transparent', // 圆角问题
            }).then(canvas => {
              this.imgBeforeShow = false;
              const dataURL = canvas.toDataURL('image/png', 1.0);
              this.dataUrl = dataURL;
            });
          }, 1000);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7;
  height: 100vh;
  width: 750px;
  background: rgba($color: #000000, $alpha: 0.7);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;

  .box {
    float: left;
    position: relative;
    // position: absolute;
    // top: 136px;
    // left: 45px;
    height: 1107px;
    width: 678px;
    // background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/check_succ_bkg.png?v=1')
    //   no-repeat;
    // background-size: cover;
    margin: 136px auto 0;

    .box_img_bkg {
      position: absolute;
      top: 0;
      left: 0;
      height: 1107px;
      width: 678px;
      z-index: 0;
    }

    .content {
      position: relative;
      width: 572px;
      height: 293px;
      background: linear-gradient(180deg, #ffffff 0%, #f8ffdb 100%);
      border-radius: 29px;
      border: 4px solid #ffffff;
      margin: 750px auto 0;
      padding: 29px 33px 0;
      z-index: 3;

      .text1 {
        width: 507px;
        height: 53px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 33px;
        color: #333333;
        line-height: 53px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .text2 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 33px;
        color: #333333;
        line-height: 51px;
        margin-top: 14px;
      }

      .text3 {
        font-weight: 600;
        font-size: 33px;
        color: #333333;
        line-height: 53px;
        margin-top: 14px;
        display: flex;
        align-items: center;
        div {
          color: #ff7f41;
        }
      }
    }
  }
  .box_img {
    float: left;
    height: 1107px;
    width: 678px;
    margin: 136px auto 0;
  }

  .tip {
    float: left;
    width: 100%;
    height: 45px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 33px;
    color: #ffffff;
    line-height: 45px;
    margin-top: 40px;
    text-align: center;
  }

  .close_box {
    float: left;
    height: 69px;
    width: 100%;
    margin-top: 51px;
    display: flex;
    justify-content: center;
    img {
      display: block;
      height: 69px;
      width: 69px;
    }
  }
}
</style>